import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pet, PetMissingReportStatus } from 'src/app/interfaces/pet';
import { PetService } from 'src/app/services/pet/pet.service';

@Component({
  selector: 'app-close-lost-pet-listing',
  templateUrl: './close-lost-pet-listing.component.html',
  styleUrls: ['./close-lost-pet-listing.component.scss']
})
export class CloseLostPetListingComponent implements OnInit {
  @Input() pet: Pet;
  @Input() reportId: number;
  loading = false;
  reportStatus: PetMissingReportStatus = PetMissingReportStatus.ClosedFound;
  petMissingReportStatus = PetMissingReportStatus;

  constructor(
    public activeModal: NgbActiveModal,
    private petService: PetService,
  ) { }

  toggleReportStatus(): void {
    this.reportStatus = this.reportStatus === PetMissingReportStatus.ClosedFound
      ? PetMissingReportStatus.ClosedDeceased
      : PetMissingReportStatus.ClosedFound;
  }

  submit(): void {
    this.loading = true;
    this.petService.reportFound(this.pet.id, this.reportStatus)
      .subscribe(
        () => {
          this.activeModal.close(this.reportStatus);
        },
        err => {
          this.activeModal.dismiss('error');
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  ngOnInit(): void {
  }
}
